type GetSelectionScopeCountArgs = {
  activeViewType: string;
  activeTabId: string;
  hasActiveFilters: boolean;
  isSearchTriggered: boolean;
  calendarTotalShipments: number | null | undefined;
  calendarToolbarTotal: number;
  totalShipments: number | null | undefined;
  overAllShipmentCount: number | null | undefined;
};

export const getSelectionScopeCount = ({
  activeViewType,
  activeTabId,
  hasActiveFilters,
  isSearchTriggered,
  calendarTotalShipments,
  calendarToolbarTotal,
  totalShipments,
  overAllShipmentCount,
}: GetSelectionScopeCountArgs): number => {
  if (activeViewType === 'calendar') {
    return hasActiveFilters
      ? (calendarTotalShipments ?? 0)
      : calendarToolbarTotal;
  }

  if (
    activeTabId === 'all_shipments' &&
    !hasActiveFilters &&
    !isSearchTriggered
  ) {
    return overAllShipmentCount ?? totalShipments ?? 0;
  }

  return totalShipments ?? 0;
};
